import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';

import { BaseCellInputComponent } from '../base-cell-input.component';

@UntilDestroy()
@Component({
  selector: 'blaze-cell-input-text',
  template: ` <input
    #stringInput
    type="text"
    [formControl]="formControl"
    [class.readonly]="column.isComputed"
    [attr.readonly]="readonly || column.isComputed ? true : null"
    class="input-string"
  />`,
  styleUrls: ['../base-cell-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule],
})
export class CellInputTextComponent extends BaseCellInputComponent<string> {
  @Input() readonly = false;

  @ViewChild('stringInput') stringInputRef!: ElementRef<HTMLInputElement>;

  override get nativeElement(): HTMLInputElement | null {
    return this.stringInputRef?.nativeElement || null;
  }
}
